// @ts-strict-ignore
import { useMutation } from '@tanstack/react-query'
import { postMassCryptoPayouts } from 'services/MasspayoutService'
import { BaseErrorResponse } from 'types/beneficiaries'
import { logSentryError } from 'utils/sentry'

export const useMassCryptoPayoutsMutation = () =>
  useMutation({
    mutationFn: postMassCryptoPayouts,
    onError: (error: BaseErrorResponse, data) => {
      if (error?.status !== 428) {
        logSentryError('Error: useMassCryptoPayoutsMution', error, data)
      }
    },
  })
